import useField, { useFieldProps } from './useField';

const useInputNumber = <T>(props: useFieldProps<T>) => {
  const field = useField(props);

  return {
    ...field,
    fieldType: 'inputNumber',
  };
};

export default useInputNumber;
